/** Query value our Teo AI agent appends when crawling client sites. */
export const TEO_AI_AGENT_UTM_VALUE = 'teoai';

/** @deprecated Use TEO_AI_AGENT_UTM_VALUE — kept for older imports. */
export const TEO_AI_AGENT_UTM_MEDIUM = TEO_AI_AGENT_UTM_VALUE;

/** Param names that mark a Teo AI agent visit when value is `teoai`. */
const TEO_AI_AGENT_PARAM_NAMES = ['utm_bot', 'utm_medium'] as const;

/**
 * True when the page URL marks a Teo AI agent visit:
 * `utm_bot=teoai` (canonical) or legacy `utm_medium=teoai`.
 * Case-insensitive; reads `window.location.search` (not hash).
 */
export function isTeoAiAgentVisit(
  search: string = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
  try {
    const params = new URLSearchParams(
      search.startsWith('?') ? search.slice(1) : search,
    );
    for (const name of TEO_AI_AGENT_PARAM_NAMES) {
      const value = params.get(name)?.trim().toLowerCase();
      if (value === TEO_AI_AGENT_UTM_VALUE) return true;
    }
    return false;
  } catch {
    return false;
  }
}
